/* eslint-disable */

import axios from "axios";

const endpoint = 'StockItem';

export default {
    async getById(stockItemId /*number*/) {
        const response = await axios.get(`${endpoint}/${stockItemId}`);
        return response.data;
    },

    async search({ orderBy /*string*/, orderDesc /*boolean*/, pageNumber /*number*/, pageSize /*number*/, searchValue /*string*/  }) {
        const options = {
            orderBy,
            orderDesc,
            pageNumber,
            pageSize,
            searchValue,
        };

        const response = await axios.post(`${endpoint}/search`, options);
        return response.data;
    },

    async update(stockItemId /*number*/, stockItem /*StockItem*/) {
        const response = await axios.put(`${endpoint}/${stockItemId}`, stockItem);
        return response.data;
    },
}
